'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReconnectedAlert = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _alertTypes = require('./constants/alertTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getReconnectedAlert = exports.getReconnectedAlert = function getReconnectedAlert() {
  return {
    id: _alertTypes.RECONNECTED_ALERT_ID,
    type: 'success',
    titleText: _I18n2.default.text('conversationsUI.alerts.pubNubStatus.PNNetworkUpCategory.title'),
    message: _I18n2.default.text('conversationsUI.alerts.pubNubStatus.PNNetworkUpCategory.description')
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/connection-alerts/getReconnectedAlert.js
// module id = 801
// module chunks = 2 3